import {httpService} from "@/modules/common/services";
import {getQuery} from "@/modules/common/utils";

const getSummary = async (params) => getQuery('clients/payments', params)
const list = async (params) => getQuery('payments', params)

const getCreditCards = async (uid) => {
  const res = await httpService.get(`platform/v1/clients/${uid}/payment/cards`);
  if (res.error) {
    return {error: res.error};
  } else {
    return {cards: res.data.cards};
  }
};

const matchPayment = async (paymentUid, params) => {
  const res = await httpService.post(`platform/v1/payments/${paymentUid}/match`, params);
};

export default {
  getSummary,
  getCreditCards,
  matchPayment,
  list
}
